import React from 'react';

/**
 * ProjectInfoSection - Visar projektstart och arbetsdagar (endast läsning)
 * Redigering görs i Kalkylen via "Förutsättningar"-sektionen
 */
// Formatera datum - om det ser ut som ett ISO-datum, formatera till sv-SE, annars visa som text
const formatDateStr = (date) => {
  if (!date) return null;
  const str = String(date);
  if (/^\d{4}-\d{2}-\d{2}/.test(str)) {
    const d = new Date(str);
    if (!isNaN(d.getTime())) {
      return d.toLocaleDateString('sv-SE', { year: 'numeric', month: 'long', day: 'numeric' });
    }
  }
  return str;
};

const ProjectInfoSection = ({ offert, procurement, user, expandedSections, toggleSection }) => {
  /**
   * Nya offerter (`datumkalla: 'kalkyl'`) tar BARA serverns värden.
   *
   * Fallbackkedjan nedan går förbi offerten och ända ut i upphandlingen, och
   * det är fel så fort offerten äger sina egna datum: en tom extra-kalkyl hade
   * visat det SÅLDA jobbets byggstart och arbetsdagar ur
   * procurement.projectInfo — för Ylva Arreström "Sommar 2026" och 65 dagar,
   * mitt i ett tillägg som ännu inte fått några värden. Exakt det läckage
   * backend stängt i getOffert.
   *
   * Saknas fältet är offerten en av de 73 befintliga, och då gäller kedjan som
   * förut — den är det som får dem att visa något alls.
   */
  const agerSinaDatum = offert?.datumkalla === 'kalkyl';
  const rawStartDate = agerSinaDatum
    ? offert?.projectStartDate
    : (offert?.projectStartDate || offert?.projectInfo?.startDate || offert?.puData?.projectInfo?.startDate || procurement?.projectInfo?.startDate);
  const rawEndDate = offert?.projectEndDate;
  const workDays = agerSinaDatum
    ? offert?.projectWorkDays
    : (offert?.projectWorkDays || offert?.projectInfo?.workDays || offert?.puData?.projectInfo?.workDays || procurement?.projectInfo?.workDays);
  const startDate = formatDateStr(rawStartDate);
  const endDate = formatDateStr(rawEndDate);

  const hasData = startDate || workDays;

  if (!hasData) {
    return null;
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-6">
      <button
        onClick={() => toggleSection('projektstart')}
        className="w-full p-6 flex items-center justify-between hover:bg-gray-50 transition-colors"
      >
        <h2 className="text-lg font-semibold text-leadme-gray-dark">Planerad projektstart</h2>
        <svg
          className={`w-5 h-5 text-gray-500 transform transition-transform ${
            expandedSections.projektstart ? 'rotate-180' : ''
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {expandedSections.projektstart && (
        <div className="px-6 pb-6">
          <p className="text-sm text-gray-600 mb-4">
            Detta är den planerade tidsramen för projektet.
            {user?.role === 'byggkonsult' && (
              <span className="text-gray-500 ml-1">(Redigeras i Kalkylen under "Förutsättningar")</span>
            )}
          </p>

          <div className="bg-green-50 border border-green-200 rounded-lg p-4">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              {startDate && (
                <div>
                  <p className="text-sm font-medium text-green-700">Startdatum</p>
                  <p className="text-base text-gray-700">{startDate}</p>
                </div>
              )}

              {endDate && (
                <div>
                  <p className="text-sm font-medium text-green-700">Estimerat slutdatum</p>
                  <p className="text-base text-gray-700">{endDate}</p>
                </div>
              )}

              {workDays && (
                <div>
                  <p className="text-sm font-medium text-green-700">Antal arbetsdagar</p>
                  <p className="text-base text-gray-700">{workDays} dagar</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectInfoSection;
